export const coursesData = [
  {
    id: 1,
    name: "JavaScript/Front-end",
    provider: "RS School",
    timeline: "20/9/2022 - 25/4/2023",
    description:
      "At <strong>RS School</strong> of <strong>JavaScript and Frontend</strong>, I finished an intense curriculum that covered HTML, CSS, JavaScript, advanced JavaScript, TypeScript, and Angular. As a result of this extensive training, I was able to create completely responsive designs and integrate powerful client-side logic. My practical projects considerably improved my abilities as a web developer.",
    link: "https://rs.school/",
  },
  {
    id: 2,
    name: "Javascript And Front-End Frameworks",
    provider: "GITA/New Horizons",
    timeline: "19/8/2022 - 18/11/2022",
    description:
      "I finished an extensive course on <strong>GITA</strong>, delving deeply into the nuances of <strong>JavaScript</strong> and learning the fundamentals of <strong>React.js</strong>. With this knowledge, I passed the <strong>Certiport IT Specialist</strong> certification test in <strong>JavaScript</strong> and earned my certification. ",
    link: "https://ict.gov.ge/trainings/javascript-and-front-end-frameworks/",
  },
];
